export const requestState = {
  NEW: 0,
  MORE_INFO: 1,
  ACCEPTED: 2,
  REJECTED: 3
};
